<script lang="ts" setup>
import type { EditorialDiscover } from '@integration-layer/ampliance/schemas/editorial-discover-schema.localized'
import type { EditorialDiscoverProps } from '@design-system/components/Editorial/EditorialDiscover.props'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialDiscover
}>()

const data = await useComponentResponse<EditorialDiscover>(props)
</script>

<template>
  <EditorialDiscover
    v-if="data"
    v-bind="data as unknown as EditorialDiscoverProps"
  />
</template>
